function accordion() {
   let dlTerms = document.querySelectorAll('.js-dl-toggle');

    dlTerms.forEach(function(term) {
          term.addEventListener('click', (event) => {
              /*term.classList.toggle('active');*/

              let termParent = term.parentElement;
              termParent.classList.toggle('active');

              let termSibling = term.nextElementSibling;
              if (!termSibling.classList.contains('active')) {
      
              termSibling.classList.add('active');
              termSibling.style.height = 'auto';

              var height = termSibling.clientHeight + 'px';

              termSibling.style.height = '0px';

              setTimeout(function () {
                termSibling.style.height = height;
              }, 0);
              
            } else {
              
              termSibling.style.height = '0px';

              termSibling.addEventListener('transitionend', function () {
                termSibling.classList.remove('active');
              }, {
                once: true
              });
              
            }

            event.preventDefault();
        });
    });
}
